// frontend/src/App.jsx
import EspecialistasListPage from "./pages/especialistas/EspecialistasListPage";
import EspecialistasFormPage from "./pages/especialistas/EspecialistasFormPage";
import PromotoresListPage from "./pages/promotores/PromotoresListPage";
import PromotoresFormPage from "./pages/promotores/PromotoresFormPage";
import MotivosMbaListPage from "./pages/motivos-mba/MotivosMbaListPage";
import MotivoMbaFormPage from "./pages/motivos-mba/MotivoMbaFormPage";
import DecisoesListPage from "./pages/decisoes/DecisoesListPage";
import DecisoesFormPage from "./pages/decisoes/DecisoesFormPage";
import MeiosSaidaListPage from "./pages/meiosSaida/MeiosSaidaListPage";
import MeiosSaidaFormPage from "./pages/meiosSaida/MeiosSaidaFormPage";
import PerfilPermissionsPage from './pages/perfis/PerfilPermissionsPage';
import MinhaContaPage from './pages/conta/MinhaContaPage';

import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

// Layouts e Autenticação
import MainLayout from "./components/layout/MainLayout";
import PainelLayout from "./components/layout/PainelLayout";
import ProtectedRoute from "./components/auth/ProtectedRoute";

// Páginas Públicas
import LoginPage from "./pages/LoginPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";

// Páginas do Painel
import DashboardPage from "./pages/DashboardPage"; // <-- caminho correto
import UnauthorizedPage from "./components/UnauthorizedPage";
import AdolescentesListPage from "./pages/adolescentes/AdolescentesListPage";
import AdolescentesFormPage from "./pages/adolescentes/AdolescentesFormPage";
import AdolescenteDetailPage from "./pages/adolescentes/AdolescenteDetailPage";

// Movimentações aninhadas do Adolescente
import AdolescenteMovimentacoesListPage from "./pages/adolescentes/AdolescenteMovimentacoesListPage";
import AdolescenteMovimentacaoFormPage from "./pages/adolescentes/AdolescenteMovimentacaoFormPage";

import SituacoesListPage from "./pages/situacoes/SituacoesListPage";
import SituacoesFormPage from "./pages/situacoes/SituacoesFormPage";
import UnidadesListPage from "./pages/unidades/UnidadesListPage";
import UnidadesFormPage from "./pages/unidades/UnidadesFormPage";
import MeiosEntradaListPage from "./pages/meiosEntrada/MeiosEntradaListPage";
import MeiosEntradaFormPage from "./pages/meiosEntrada/MeiosEntradaFormPage";
import ModulosListPage from "./pages/modulos/ModulosListPage";
import ModulosFormPage from "./pages/modulos/ModulosFormPage";
import OrgaosListPage from "./pages/orgaos/OrgaosListPage";
import OrgaosFormPage from "./pages/orgaos/OrgaosFormPage";
import PerfisListPage from "./pages/perfis/PerfisListPage";
import PerfisFormPage from "./pages/perfis/PerfisFormPage";
import PerfilViewPage from "./pages/perfis/PerfilViewPage";
import PerfilDashboardConfigPage from "./pages/perfis/PerfilDashboardConfigPage";
import UsuariosListPage from "./pages/usuarios/UsuariosListPage";
import UsuariosFormPage from "./pages/usuarios/UsuariosFormPage";

// Relatórios (novidade)
import RelatoriosPage from "./pages/relatorios/RelatoriosPage";

// Manual do Usuário
import ManualLayout from "./components/layout/ManualLayout";
import ManualHomePage from "./pages/manual/ManualHomePage";

// Dashboard de Logs
import LogsPage from "./pages/LogsPage";
import ManualIntroducaoPage from "./pages/manual/ManualIntroducaoPage";
import ManualPrimeiroAcessoPage from "./pages/manual/ManualPrimeiroAcessoPage";
import ManualAdolescentesPage from "./pages/manual/ManualAdolescentesPage";
import ManualMovimentacoesPage from "./pages/manual/ManualMovimentacoesPage";
import ManualDashboardPage from "./pages/manual/ManualDashboardPage";
import ManualRelatoriosPage from "./pages/manual/ManualRelatoriosPage";
import ManualPerguntasFrequentesPage from "./pages/manual/ManualPerguntasFrequentesPage";
import ManualAtendimentosPage from "./pages/manual/ManualAtendimentosPage";
import ManualUsuariosPage from "./pages/manual/ManualUsuariosPage";
import ManualConfiguracoesPage from "./pages/manual/ManualConfiguracoesPage";
import ManualGlossarioPage from "./pages/manual/ManualGlossarioPage";
import ManualMinhaContaPage from "./pages/manual/ManualMinhaContaPage";
import ManualLogsPage from "./pages/manual/ManualLogsPage";

function ManualScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (!pathname.startsWith("/painel/manual")) return;

    const resetScroll = () => {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;

      const mainContent = document.querySelector(".main-content");
      if (mainContent) {
        mainContent.scrollTop = 0;
      }
    };

    resetScroll();
    requestAnimationFrame(resetScroll);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <BrowserRouter>
      <ManualScrollToTop />
      <Routes>
        {/* Rotas Públicas */}
        <Route path="/" element={<MainLayout />} />

        <Route path="/login" element={<LoginPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/unauthorized" element={<UnauthorizedPage />} />

        {/* Rotas Privadas */}
        <Route element={<ProtectedRoute />}>
          <Route path="/painel" element={<PainelLayout />}>
            <Route index element={<DashboardPage />} />
            <Route path="dashboard" element={<DashboardPage />} />
            
            {/* Minha Conta */}
            <Route path="minha-conta" element={<MinhaContaPage />} />

            {/* Adolescentes */}
            <Route path="adolescentes/novo" element={<AdolescentesFormPage />} />
            <Route path="adolescentes/:id/editar" element={<AdolescentesFormPage />} />
            <Route path="adolescentes/:id" element={<AdolescenteDetailPage />} />
            <Route path="adolescentes" element={<AdolescentesListPage />} />

            {/* Movimentações aninhadas do Adolescente */}
            <Route path="adolescentes/:id/movimentacoes" element={<AdolescenteMovimentacoesListPage />} />
            <Route path="adolescentes/:id/movimentacoes/novo" element={<AdolescenteMovimentacaoFormPage />} />

            {/* Relatórios */}
            <Route path="relatorios" element={<RelatoriosPage />} />

            {/* Situações */}
            <Route path="situacoes" element={<SituacoesListPage />} />
            <Route path="situacoes/novo" element={<SituacoesFormPage />} />
            <Route path="situacoes/:id/editar" element={<SituacoesFormPage />} />

            {/* Unidades */}
            <Route path="unidades" element={<UnidadesListPage />} />
            <Route path="unidades/novo" element={<UnidadesFormPage />} />
            <Route path="unidades/:id/editar" element={<UnidadesFormPage />} />

            {/* Meios de Entrada */}
            <Route path="meios-entrada" element={<MeiosEntradaListPage />} />
            <Route path="meios-entrada/novo" element={<MeiosEntradaFormPage />} />
            <Route path="meios-entrada/:id/editar" element={<MeiosEntradaFormPage />} />

            {/* Meios de Saída */}
            <Route path="meios-saida" element={<MeiosSaidaListPage />} />
            <Route path="meios-saida/novo" element={<MeiosSaidaFormPage />} />
            <Route path="meios-saida/:id/editar" element={<MeiosSaidaFormPage />} />

            {/* Decisões */}
            <Route path="decisoes" element={<DecisoesListPage />} />
            <Route path="decisoes/novo" element={<DecisoesFormPage />} />
            <Route path="decisoes/:id/editar" element={<DecisoesFormPage />} />

            {/* Motivos MBA */}
            <Route path="motivos-mba" element={<MotivosMbaListPage />} />
            <Route path="motivos-mba/novo" element={<MotivoMbaFormPage />} />
            <Route path="motivos-mba/:id/editar" element={<MotivoMbaFormPage />} />

            {/* Especialistas */}
            <Route path="especialistas" element={<EspecialistasListPage />} />
            <Route path="especialistas/novo" element={<EspecialistasFormPage />} />
            <Route path="especialistas/:id/editar" element={<EspecialistasFormPage />} />

            {/* Promotores */}
            <Route path="promotores" element={<PromotoresListPage />} />
            <Route path="promotores/novo" element={<PromotoresFormPage />} />
            <Route path="promotores/:id/editar" element={<PromotoresFormPage />} />

            {/* Módulos */}
            <Route path="modulos" element={<ModulosListPage />} />
            <Route path="modulos/novo" element={<ModulosFormPage />} />
            <Route path="modulos/:id/editar" element={<ModulosFormPage />} />

            {/* Órgãos */}
            <Route path="orgaos" element={<OrgaosListPage />} />
            <Route path="orgaos/novo" element={<OrgaosFormPage />} />
            <Route path="orgaos/:id/editar" element={<OrgaosFormPage />} />

            {/* Perfis */}
            <Route path="perfis" element={<PerfisListPage />} />
            <Route path="perfis/novo" element={<PerfisFormPage />} />
            <Route path="perfis/:id/editar" element={<PerfisFormPage />} />
            <Route path="perfis/:id/visualizar" element={<PerfilViewPage />} />
            <Route path="perfis/:id/dashboard-config" element={<PerfilDashboardConfigPage />} />

            {/* Usuários */}
            <Route path="usuarios" element={<UsuariosListPage />} />
            <Route path="usuarios/novo" element={<UsuariosFormPage />} />
            <Route path="usuarios/:id/editar" element={<UsuariosFormPage />} />

            {/* Página de Permissões do Perfil */}
            <Route path="perfis/:id/permissoes" element={<PerfilPermissionsPage />} />

            {/* Dashboard de Logs - Apenas para admins */}
            <Route path="logs" element={<LogsPage />} />

            {/* Manual do Usuário */}
            <Route path="manual" element={<ManualHomePage />} />
            <Route path="manual/introducao" element={<ManualIntroducaoPage />} />
            <Route path="manual/primeiro-acesso" element={<ManualPrimeiroAcessoPage />} />
            <Route path="manual/adolescentes" element={<ManualAdolescentesPage />} />
            <Route path="manual/movimentacoes" element={<ManualMovimentacoesPage />} />
            <Route path="manual/atendimentos" element={<ManualAtendimentosPage />} />
            <Route path="manual/dashboard" element={<ManualDashboardPage />} />
            <Route path="manual/relatorios" element={<ManualRelatoriosPage />} />
            <Route path="manual/usuarios" element={<ManualUsuariosPage />} />
            <Route path="manual/configuracoes" element={<ManualConfiguracoesPage />} />
            <Route path="manual/minha-conta" element={<ManualMinhaContaPage />} />
            <Route path="manual/logs" element={<ManualLogsPage />} />
            <Route path="manual/glossario" element={<ManualGlossarioPage />} />
            <Route path="manual/perguntas-frequentes" element={<ManualPerguntasFrequentesPage />} />
            
            </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
